import { TextField, IconButton, Grid, Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider } from '@mui/material'
import { useEffect, useRef, useState, useCallback } from 'react'
import { useStyles } from '../../style/styles'
import { styled } from '@mui/material/styles'
// changed to import * as utils
import { createChannel, createChannelMembership, createUserArn, listChannelMessages, publishMessagingEvent, sendChannelMessage, updateChannelMarkerBackend, updateReadMarker } from '../../lib/messageUtils'
import { IProps } from './types'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import { MessagingConstants } from '../../lib/enums'
import { setChannelData, updateChannelArn, updateChannelMessageList } from '../../redux/channel/actions'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../redux/channel/types'
import * as utils from '../../lib/messageUtils'
import TermsOfService from '../TermsOfService'
import ReEnablePrompt from '../ReEnableChatPrompt'

const ChatInput = (props: IProps) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const channelsReducer = useSelector((state: RootState) => state.channels.channels)
  const [message, setMessage] = useState('')
  const textInputRef = useRef<HTMLInputElement>(null);
  const [textInputFocused, setTextInputFocused] = useState(false)
  const [textareaHeight, setTextareaHeight] = useState('38px')
  const { channel, receiver, sender, job, connections, platform, adminID, endOrReenableActionDoer, updatedChannel, aiInterviewer, onSendMessage, channelMetadata} = props
  const { channelArn, channelName, metadata, isEndedConversation } = channel
  const isRecruiter = (sender.role?.toUpperCase() === MessagingConstants.RECRUITER)
  const [isSelf, setIsSelf] = useState<boolean>(false)
  const [inputHeight, setInputHeight] = useState('auto')
  const inputRef = useRef<HTMLDivElement>(null);
  const [isPromptModalOpen, setIsPromptModalOpen] = useState(false)
  const [isTextFieldDisabled, setIsTextFieldDisabled] = useState<boolean>(false)
  const [isSendDisabled, setIsSendDisabled] = useState<boolean>(false)
  const [isMessageNotEmpty, setIsMessageNotEmpty] = useState<boolean>(true)

  // const [isEndOrReenabledActionDoer, setIsEndOrReenabledActionDoer] = useState<boolean>(endOrReenableActionDoer == sender.userArn ? true : false)

  const DrawerCornerRadius = styled(SwipeableDrawer)(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: '8px',
    },
  }));;

  var isEndOrReenabledActionDoer = endOrReenableActionDoer == sender.userArn ? true : false

  useEffect(() => {
    if(aiInterviewer && aiInterviewer?.draftMessage && aiInterviewer?.draftMessage != "") {
      const formattedMessage = aiInterviewer.draftMessage.replace(/\\n/g, '\n')
      setMessage(formattedMessage)
    }
  }, [aiInterviewer?.draftMessage])

  useEffect(() => {
    if(connections.isBlocked || connections.isBlockedLink) {
      setIsTextFieldDisabled(true)
      setIsSendDisabled(true)
    }
    else{
      if (updatedChannel && updatedChannel?.ChannelSummary?.Metadata) {
        setIsMessageNotEmpty(message != null && message.trim().length > 0)
        const parsedMetadata = updatedChannel?.ChannelSummary?.Metadata ? JSON.parse(updatedChannel?.ChannelSummary?.Metadata) : null
        isEndOrReenabledActionDoer = parsedMetadata.EndOrReenableActionDoer == sender.userArn ? true : false

        if (parsedMetadata?.BlockedBy && parsedMetadata.BlockedBy.trim() !== '') {
          setIsTextFieldDisabled(true)
          setIsSendDisabled(true)
        } else {
          if(isEndedConversation) {
            if(isEndOrReenabledActionDoer) {
              setIsTextFieldDisabled(false)
              if(message != null && message.trim().length > 0) {
                setIsSendDisabled(false)
               } else {
                setIsSendDisabled(true)
              }
            } else {
              setIsTextFieldDisabled(true)
              setIsSendDisabled(true)
            }
          } else {
            setIsTextFieldDisabled(false)
            if(message != null && message.trim().length > 0) {
              setIsSendDisabled(false)
            } else {
              setIsSendDisabled(true)
           }
          }
        }
      } else {
        if(message != null && message.trim().length > 0) {
          setIsSendDisabled(false)
        } else {
          setIsSendDisabled(true)
        }
        setIsTextFieldDisabled(false)
      }
    }
  }, [connections, metadata, updatedChannel, message])

  useEffect(() => {
    const channelData = channelsReducer?.[channelName]
    const messageList = channelData?.messageList

    if (channelData && messageList) {
      const newIsSelf = utils.checkIsLastMessageSender(messageList, sender.userArn)
      setIsSelf(newIsSelf)
    }
  }, [channelsReducer, channelName, sender.userArn])

  /* ResizeObserver for monitoring input height changes for dynamic chatBody adjustment */
  useEffect(() => {
    const inputElement = textInputRef.current;
    if (inputElement && platform !== 'mobile') {
      const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          const height = entry.contentRect.height;
          const containerPadding = 20
          const totalHeight = Math.max(height + containerPadding, 45) /* min height: 45px */
          document.documentElement.style.setProperty('--default-input-height', `${totalHeight}px`)
        }
      });
      resizeObserver.observe(inputElement);
      return () => resizeObserver.disconnect();
    }
  }, [platform])

  const checkMessageSubmission = (e: any) => {
    e.preventDefault();

    if (isEndedConversation && isEndOrReenabledActionDoer) {
      setIsPromptModalOpen(true);
    } else {
      setIsPromptModalOpen(false);
      if(isMessageNotEmpty) {
        handleNewMessageSubmit(e);
      }
    }
  };

  const handleNewMessageSubmit = async (e?: any) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    let trimmedMessage = message.trim()
    onSendMessage?.(true)

    /* START: TJSKR-2780 (append <a> tag to link in message submission)*/
    if (
      aiInterviewer &&
      aiInterviewer?.draftMessage &&
      aiInterviewer?.interviewLink &&
      aiInterviewer.draftMessage.trim() !== "" &&
      aiInterviewer.interviewLink.trim() !== ""
    ) {
      const { draftMessage, interviewLink } = aiInterviewer
      if (trimmedMessage.includes(interviewLink)) {
        trimmedMessage = trimmedMessage.replace(interviewLink, `<a>${interviewLink}</a>`)
      }
    }
    /* END: TJSKR-2780 */

    setMessage('')
    if(platform !== 'mobile') {
      document.documentElement.style.setProperty('--default-input-height', '45px');
    }
    e.preventDefault()
    let sentMessages = null
    let receiverData = { externalUserId: receiver.externalUserId, messagingId: receiver.userArn, role: receiver.role }
    const senderData = { externalUserId: sender.externalUserId, messagingId: sender.userArn, role: sender.role }

    let jobseekerUnreadCount = 0
    if(sender?.role == "Recruiter") {
      jobseekerUnreadCount = receiver?.userArn ? (await utils.getJobseekerUnreadCount(receiver?.externalUserId, receiver?.userArn)) + 1 : 1
    }

    /* IF channel is not existing: CREATE NEW CHANNEL */
      if (!channelArn || channelArn === '') {
        try {
          let receiverArn = receiver.userArn
          if(!receiverArn) {
            receiverArn = await createUserArn(receiver)
            receiverData.messagingId = receiverArn
            props.onReceiverArnUpdate?.(receiverArn)
          }
          
          if(receiverArn) {
            const newChannel = await createChannel(channelName, job, receiverData, senderData, channelMetadata)
            const newChannelArn = newChannel.channelArn
            const newChannelMetadata = JSON.stringify(newChannel.metadata)
            dispatch(updateChannelArn(channelName, newChannelArn))
            // await createChannelMembership(receiverArn, newChannelArn)
            sentMessages = await sendChannelMessage(senderData, receiverData, newChannelArn, trimmedMessage, aiInterviewer?.interviewLink)
            // update channel marker after sending FIRST message
            if(sentMessages && newChannelArn && newChannelArn !== '') {
              updateReadMarker(sender.userArn, newChannelArn, true, receiverData)
              publishMessagingEvent("channelCreated", sender.userArn, newChannelArn, "", "", newChannelMetadata, null, null)
              window.parent.postMessage({ type: 'HANDLE_NEW_CHANNEL', jobseekerId: receiver.externalUserId, jobId: job.job_id, channelArn: newChannelArn }, '*');
              /* DISABLED FEATURE TJSKR-1572: update terms of service agreed after sending first message */
              /* utils.updateTermsOfServiceAgreed(sender.userArn)
                window.parent.postMessage({ type: MessagingConstants.TERMS_OF_SERVICE_ACCEPTED, userArn: sender.userArn }, '*'); */

                /*  Code here to send push notification */
              const convertedNotifMessage = trimmedMessage.replaceAll('\n', '\\n')
              /* OLD GCM */
              // let gcm = `{ \"notification\": { \"body\": \"${convertedNotifMessage}\", \"title\": \"New Message from ${sender?.info?.first_name}\" }, \"data\": { \"recruiterId\": \"${sender.externalUserId}\", \"recruiterName\": \"${sender?.info?.first_name} ${sender?.info?.last_name}\", \"jobseekerId\": \"${receiver.externalUserId}\", \"position\": \"${job.position}\", \"company\": \"${job.company}\", \"jobId\": \"${job.job_id}\", \"recruiterEmail\": \"${sender?.info?.email}\", \"channelArn\": \"${newChannelArn}\" } }`
              let gcm = `{ \"notification\": { \"body\": \"${convertedNotifMessage}\", \"title\": \"New Message from ${sender?.info?.first_name}\", \"badge\": ${jobseekerUnreadCount} }, \"data\": { \"recruiterId\": \"${sender.externalUserId}\", \"recruiterName\": \"${sender?.info?.first_name} ${sender?.info?.last_name}\", \"jobseekerId\": \"${receiver.externalUserId}\", \"position\": \"${job.position}\", \"company\": \"${job.company}\", \"jobId\": \"${job.job_id}\", \"recruiterEmail\": \"${sender?.info?.email}\", \"channelArn\": \"${newChannelArn}\" }, \"apns\": { \"headers\": { \"apns-priority\": \"10\" }, \"payload\": { \"aps\": { \"sound\": \"default\", \"badge\": ${jobseekerUnreadCount} } } } }`;
              await utils.sendPushNotification(receiver.userArn, '', gcm)
            }
          }
      } catch (err) {
        alert(`Unable to create user due to some missing fields`)
      }}

    /* for existing channels */
    else {
      if (isEndedConversation) {
        try {
          await updateChannelMarkerBackend(channelArn, sender.userArn, adminID, MessagingConstants.REENABLE_CONVERSATION_MARKER, null, receiver)
          await updateReadMarker(sender.userArn, channelArn, true, receiver)
          window.parent.postMessage({ type: MessagingConstants.REENABLE_CONVERSATION_MARKER, jobseekerId: receiver.externalUserId, jobId: job.job_id }, '*');
        } catch (err) { throw err }
      }
      if (isMessageNotEmpty && channelArn) {
        try {
          sentMessages = await sendChannelMessage(senderData, receiverData, channelArn, trimmedMessage, aiInterviewer?.interviewLink)
          // update channel marker after sending message
          if(sentMessages && channelArn && channelArn !== '') {
            updateReadMarker(sender.userArn, channelArn, true, receiver)
          }

        /*  Code here to send push notification */
        const convertedNotifMessage = trimmedMessage.replaceAll('\n', '\\n')
        /* OLD GCM */
        // let gcm = `{ \"notification\": { \"body\": \"${convertedNotifMessage}\", \"title\": \"New Message from ${sender?.info?.first_name}\" }, \"data\": { \"recruiterId\": \"${sender.externalUserId}\", \"recruiterName\": \"${sender?.info?.first_name} ${sender?.info?.last_name}\", \"jobseekerId\": \"${receiver.externalUserId}\", \"position\": \"${job.position}\", \"company\": \"${job.company}\", \"jobId\": \"${job.job_id}\", \"recruiterEmail\": \"${sender?.info?.email}\", \"channelArn\": \"${channelArn}\" } }`
        let gcm = `{ \"notification\": { \"body\": \"${convertedNotifMessage}\", \"title\": \"New Message from ${sender?.info?.first_name}\", \"badge\": ${jobseekerUnreadCount} }, \"data\": { \"recruiterId\": \"${sender.externalUserId}\", \"recruiterName\": \"${sender?.info?.first_name} ${sender?.info?.last_name}\", \"jobseekerId\": \"${receiver.externalUserId}\", \"position\": \"${job.position}\", \"company\": \"${job.company}\", \"jobId\": \"${job.job_id}\", \"recruiterEmail\": \"${sender?.info?.email}\", \"channelArn\": \"${channelArn}\" }, \"apns\": { \"headers\": { \"apns-priority\": \"10\" }, \"payload\": { \"aps\": { \"sound\": \"default\", \"badge\": ${jobseekerUnreadCount} } } } }`;
        await utils.sendPushNotification(receiver.userArn, '', gcm)
        } catch (err) { throw err }
      }
    }

    // textInputRef.current?.focus();
  }

  const handlePromptAction = async (accepted: boolean) => {
    setIsPromptModalOpen(false); // Close the modal
    if (accepted) {
       // User accepted the Re-Enable Chat Prompt, proceeding with message submission
      const trimmedMessage = message.trim()
      await updateChannelMarkerBackend(channelArn, sender.userArn, adminID, MessagingConstants.REENABLE_CONVERSATION_MARKER, null, receiver);
      await sendMessage(trimmedMessage)
       /*  Code here to send push notification */
      const convertedNotifMessage = trimmedMessage.replaceAll('\n', '\\n')
      let gcm = `{ \"notification\": { \"body\": \"${convertedNotifMessage}\", \"title\": \"New Message from ${sender?.info?.first_name}\" }, \"data\": { \"recruiterId\": \"${sender.externalUserId}\", \"recruiterName\": \"${sender?.info?.first_name} ${sender?.info?.last_name}\", \"jobseekerId\": \"${receiver.externalUserId}\", \"position\": \"${job.position}\", \"company\": \"${job.company}\", \"jobId\": \"${job.job_id}\", \"recruiterEmail\": \"${sender?.info?.email}\", \"channelArn\": \"${channelArn}\" } }`
      await utils.sendPushNotification(receiver.userArn, '', gcm)
    }

    setMessage(''); // Clear the message input
  }
    const sendMessage = async (text: string) => {
      setMessage('')
      await sendChannelMessage(
        { ...sender, messagingId: sender.userArn },
        { ...receiver, messagingId: receiver.userArn },
        channelArn!,
        text,
        aiInterviewer?.interviewLink
      )
  };

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      // Allow typing without showing the prompt if the user ended the conversation
      setMessage(event.target.value);
      if (platform !== 'mobile') {
        updateInputHeight();
      }
    };

  const handleFocus = () => {
    props.onFocus(true)
    setTextInputFocused(true)
  }

  const handleBlur = () => {
    props.onFocus(false)
    setTextInputFocused(false)
  }

  const updateInputHeight = () => {
    const inputElement = textInputRef.current;
    if (inputElement) {
      // Get the actual height of the input element
      const inputHeight = inputElement.offsetHeight;
      // Add padding and container height to get total ChatInput height
      const containerPadding = 20; // Account for container padding and margins
      const totalHeight = Math.max(inputHeight + containerPadding, 45); // Minimum height of 45px
      document.documentElement.style.setProperty('--default-input-height', `${totalHeight}px`);
    }
  }

  return (
    <div className={platform == 'mobile' ? classes.chatInput : classes.chatInputWeb}>
      { platform == 'mobile' ?
      <Grid
        container
        direction="row"
        height="inherit"
        justifyContent="flex-start"
        padding="1px 24px 1px 24px"
        alignItems="center"
        spacing={0}
        width="100%"
        sx={{ backgroundColor: 'white' }}
      >
        <Box
          sx={{
            borderRadius: '50px',
            overflow: 'hidden',
            border: '1px solid #8CB6EB',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            backgroundColor: 'white',
          }}
        >
          <Grid item xs>
            <TextField
              variant="outlined"
              fullWidth
              // autoFocus
              multiline
              disabled={isTextFieldDisabled}
              value={message}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              placeholder="Write a Message"
              inputRef={textInputRef}
              InputProps={{
                style: {
                  padding: '6px 12px',
                  whiteSpace: 'pre-line',
                  overflow: 'visible',
                },
              }}
              sx={{
                boxSizing: 'border-box',
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': { border: 'none' },
                  padding: 0,
                  alignItems: 'center',
                  height: '40px',
                  overflow: 'visible',
                },
                '& .MuiInputBase-input': {
                  lineHeight: '1.4 !important',
                  height: '35px !important',
                  maxHeight: '35px !important',
                  minHeight: '35px !important',
                  overflowY: 'auto !important',
                  overflowX: 'hidden !important',
                  display: 'block !important',
                  resize: 'none !important',
                  wordWrap: 'break-word !important',
                  whiteSpace: 'pre-wrap !important',
                  fontSize: '16px !important',
                  background: 'transparent !important',
                  textAlign: 'left !important',
                  paddingTop: '10px !important',
                },
              }}
            />
          </Grid>

          {/* Send Button */}
          <Grid
            item
            sx={{
              padding: '0px 8px 0px 0px',
              display: 'flex',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <IconButton
              sx={{ padding: '10px 10px 10px 0px' }}
              color="primary"
              onClick={checkMessageSubmission}
              disabled={isSendDisabled}
            >
              <img
                src={isSendDisabled ? '/images/Send-disabled.svg' : '/images/Send.svg'}
                alt="Send message"
                width={22}
                height={22}
              />
            </IconButton>
          </Grid>
        </Box>
      </Grid>
      :
      <Grid
        container
        direction='row'
        height='inherit'
        justifyContent='flex-start'
        alignItems="center"
        padding='1px 24px 1px 24px'
        width='100%'
        sx={{ position: 'relative' }}
      >
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: '5px',
            width: '95%',
            padding: '5px',
            display: 'flex'
          }}
        >
          <TextField
            variant="outlined"
            sx={{
              boxSizing: 'border-box',
              width: '100%',
              borderRadius: '5px',
              resize: 'none',
              backgroundColor: 'white'
            }}
            autoFocus
            fullWidth
            ref={textInputRef}
            placeholder="Write a Message"
            value={message}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            InputProps={{
              style: {
                minHeight: '45px',
                whiteSpace: 'pre-line',
              },
            }}
            multiline
            minRows={1}
            maxRows={10}
            disabled={isTextFieldDisabled}
          />
          <Grid item sx={{ padding: '0px 8px', display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
            <IconButton
              sx={{ padding: '0px', marginBottom: '8px' }}
              color="primary"
              onClick={checkMessageSubmission}
              disabled={isSendDisabled}
            >
              <img
                src={
                  isSendDisabled ?
                  "/images/Send-disabled.svg" :
                  "/images/Send.svg"
                }
                alt="Send message"
                width={22}
                height={22}
              />
            </IconButton>
          </Grid>
        </Box>
      </Grid>
      }
      {/* add condition to only render when isPromptOptn is true */}
      { isPromptModalOpen
        ? <ReEnablePrompt openPopIn={true} handleResponse={handlePromptAction} isEndedConversation={isEndedConversation} />
        : null
      }
    </div>
  )
}
                   
export default ChatInput
